import Service, { service } from '@ember/service'
import config from 'teacher-ui-client/config/environment'
import type AnalyticsService from 'teacher-ui-client/services/analytics'
import { join } from 'teacher-ui-client/utils/uri'

const logoutUrl = config.loginUrl.replace('login', 'logout')

export default class LogoutService extends Service {
  @service analytics!: AnalyticsService

  logoutAndRedirect = () => {
    this.analytics.clearUser()
    window.location.href = logoutUrl
  }

  /**
   * Intended for use by parent homeschool, to logout and go to a specific parent page via the readingeggs host.
   *
   * Receives paths like /parent_ui/dashboard
   */
  logoutAndRedirectToReadingeggs = (path: string) => {
    this.analytics.clearUser()

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = logoutUrl

    // Add return_to parameter
    const returnToInput = document.createElement('input')
    returnToInput.type = 'hidden'
    returnToInput.name = 'return_to'
    returnToInput.value = join(config.readingEggsBaseUrl, path).href

    // Add login_provider parameter
    const loginProviderInput = document.createElement('input')
    loginProviderInput.type = 'hidden'
    loginProviderInput.name = 'login_provider'
    loginProviderInput.value = 'nextgen_blake'

    // Append inputs to the form
    form.appendChild(returnToInput)
    form.appendChild(loginProviderInput)

    // Append form to the document and submit
    document.body.appendChild(form)
    form.submit()
  }
}

declare module '@ember/service' {
  interface Registry {
    logout: LogoutService
  }
}
